// Import package components
import { useMemo, useEffect, useContext, useRef, useState } from "react";

// Import base components
import { Button } from "../../../ui";
import { AppContexts } from "../../../providers";

const Tags = ({ value, onChange, readOnly = false }) => {
  const settingsContext = useContext(AppContexts.SettingsContext);

  const [searchValue, setSearchValue] = useState("");
  const [filteredTagValues, setFilteredTagValues] = useState([]);

  const dropdownRef = useRef(null);

  const tagValues = useMemo(() => {
    if (!settingsContext.settings) {
      return [];
    } else {
      if (!settingsContext.settings.tags) {
        return [];
      } else {
        return settingsContext.settings.tags.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      }
    }
  }, [settingsContext.settings]);

  useEffect(() => {
    setFilteredTagValues(tagValues.filter(tag => tag.name.toLowerCase().includes(searchValue.toLowerCase())));
  }, [tagValues, searchValue]);

  const handleInputChange = (tagId, selected) => {
    if (selected) {
      onChange([...value, tagValues.find((tagValue) => tagValue.id === tagId)]);
    } else {
      onChange(value.filter((tag) => tag.id !== tagId));
    }
  };

  const openTags = (e) => {
    e.stopPropagation();
    if (
      dropdownRef.current?.classList &&
      !dropdownRef.current.classList.contains("uk-open")
    ) {
      const handler = () => {
        window.removeEventListener("click", handler);
        dropdownRef.current?.classList.remove("uk-open");
        setSearchValue('');
      };

      window.addEventListener("click", handler);
      dropdownRef.current.classList.add("uk-open");
    }
  };

  return (
    <div className="uk-flex uk-flex-top" onClick={openTags}>
      <div>
        <Button>
          <img src="/images/tag.svg" />
        </Button>
        <div className="uk-dropdown guest-tags-dropdown" ref={dropdownRef}>
          <div className="uk-search uk-search-default uk-margin-small-bottom">
            {searchValue && searchValue !== "" ? (
              <a
                className="uk-form-icon-flip uk-form-icon"
                uk-icon="icon: close"
                onClick={() => setSearchValue("")}
              ></a>
            ) : (
              <span
                className="uk-search-icon-flip"
                uk-search-icon="true"
              />
            )}
            <input
              className="uk-search-input"
              type="search"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <ul className="uk-nav uk-dropdown-nav tags-selector">
            {filteredTagValues.map((tagValue, index) => (
              <li key={`tagValues_list_${index}`}>
                <label>
                  <input
                    className="uk-checkbox"
                    type="checkbox"
                    checked={
                      value?.findIndex((tag) => tag.id === tagValue.id) >= 0
                    }
                    onChange={
                      readOnly
                        ? () => {}
                        : (event) =>
                            handleInputChange(tagValue.id, event.target.checked)
                    }
                  />
                  {tagValue.name}
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="hms-guest-tags">
        <div className="guest-tags">
          {value &&
            value.map((tagValue, index) => (
              <div className="uk-inline" key={`tag_div_${index}`}>
                {tagValue.name}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Tags;
